import { RefObject } from 'react'

import { HeaderGroup } from '@tanstack/react-table'

import { ColumnHeaderActionsConfig } from './headerActions'
import TableHeaderCell, { StyledTD } from './TableHeaderCell'
import { getStickyColumnProperties } from './util'

type Props<TData> = {
  headerActions: ColumnHeaderActionsConfig | null
  headersByColumnKeyRef: RefObject<Map<string, HTMLTableCellElement>>
  isLoading: boolean
  isScrolledToLeft: boolean
  isScrolledToRight: boolean
  isStickyHeader: boolean
  isSortingEnabled: boolean
  headerGroups: HeaderGroup<TData>[]
}
const TableHeader = <TData,>({
  headerActions,
  headersByColumnKeyRef,
  isLoading,
  isScrolledToLeft,
  isScrolledToRight,
  isStickyHeader,
  isSortingEnabled,
  headerGroups,
}: Props<TData>) => {
  const hasHeaders = headerGroups.some((hg) => hg.headers.length > 0)
  return (
    <thead className="p-0">
      {!!isLoading && !hasHeaders && (
        <tr>
          <StyledTD
            $isScrolledToLeft={isScrolledToLeft}
            $isScrolledToRight={isScrolledToRight}
            $isStickyHeader={isStickyHeader}
            $left={0}
            $right={0}
            $stickiness="none"
            $width="100%"
          />
        </tr>
      )}
      {headerGroups.map((headerGroup) => {
        return (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header, index, arr) => {
              const { isLastLeftStickyColumn, isFirstRightStickyColumn, left, right, stickiness } =
                getStickyColumnProperties(header, index, arr, headersByColumnKeyRef)
              return (
                <TableHeaderCell
                  header={header}
                  headerActions={headerActions}
                  headersByColumnKeyRef={headersByColumnKeyRef}
                  isScrolledToLeft={isScrolledToLeft && isLastLeftStickyColumn}
                  isScrolledToRight={isScrolledToRight && isFirstRightStickyColumn}
                  isStickyHeader={isStickyHeader}
                  isSortingEnabled={isSortingEnabled}
                  key={header.id}
                  left={left}
                  right={right}
                  stickiness={stickiness}
                />
              )
            })}
          </tr>
        )
      })}
    </thead>
  )
}

export default React.memo(TableHeader) as typeof TableHeader
